// extracted by mini-css-extract-plugin
export default {"responsiveContainer":"AS9_lPrMw5gd43K62QPM","gameVoteContainer":"QP2On66QFqwaNJGv5ixy"};